import {
  forwardRef,
  InputGroup as ChakraInputGroup,
  InputGroupProps as ChakraInputGroupProps,
  useMultiStyleConfig
} from '@chakra-ui/react';
import { mergeWith } from '@chakra-ui/utils';
import React from 'react';

import { DisplayNames } from './enums';

import { getChild } from '_helpers';

export type InputGroupProps = ChakraInputGroupProps;

const InputGroup = forwardRef<InputGroupProps, 'input'>(
  (props: InputGroupProps, ref): React.ReactElement => {
    const { children, __css } = props;

    const hasRightElement = !!getChild(DisplayNames.InputRightElement, children);
    const hasLeftElement = !!getChild(DisplayNames.InputLeftElement, children);
    const hasLeftAddon = !!getChild(DisplayNames.InputLeftAddon, children);
    const hasRightAddon = !!getChild(DisplayNames.InputRightAddon, children);
    const childrenArray: Array<any> = React.Children.toArray(children);
    const isDisabled = childrenArray.map(c => !!c.props?.isDisabled).includes(true);

    const { group: styles } = useMultiStyleConfig('Input', {
      hasRightElement,
      hasLeftElement,
      hasLeftAddon,
      hasRightAddon,
      isDisabled,
      ...props
    });

    return <ChakraInputGroup __css={mergeWith(styles, __css)} ref={ref} {...props} />;
  }
);

InputGroup.displayName = DisplayNames.InputGroup;

export default InputGroup;
